function openSubmenu() {
  if ($('.has-submenu').length > 0) {
    $('.mega-menu .has-submenu > a').on('click', function(e) {
      e.preventDefault();
      $('body').toggleClass('disable-scroll');
      if ($(this).parent().hasClass('menu-current-item')) {
        $('.has-submenu').removeClass('menu-current-item');
        $(this).parent().removeClass('menu-current-item');
        $('.overlay').removeClass('visible');
      } else {
        $('.has-submenu').removeClass('menu-current-item');
        $(this).parent().addClass('menu-current-item');
        $('.overlay').addClass('visible');
      }
    });

    $('.overlay').on('click', function(e) {
      if (!$(e.target).closest('.mega-menu a').length > 0) {
        $('body').removeClass('disable-scroll');
        $('.mega-menu .has-submenu').removeClass('menu-current-item');
        $('.overlay').removeClass('visible');
      }
    });
  }
}

export default { openSubmenu };



// WEBPACK FOOTER //
// ./src/js/custom/navigation.js